export const nextGift = (theme) => ({
    root: {
        width: "100%",
        padding: theme.spacing(8, 16),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(5, 2),
            overflowX: "hidden",
        },
    },
    title: {
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(4),
            textAlign: "center",
        },
    },
    box: {
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
        },
    },
    icon: {
        height: 60,
        width: "auto",
        [theme.breakpoints.down("sm")]: {
            height: 30,
        },
    },
    hashtag: {
        borderRight: "1px solid #F1F1F1",
    },
    figure: {
        maxHeight: 300,
        width: "auto",
        maxWidth: "100%",
    },
    figureIntro: {
        width: "20%",
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            paddingRight: 0,
            paddingBottom: theme.spacing(4),
        },
    },
    slider: {
        "& .slick-list": {
            overflow: "visible",
            width: "85%",
        },
    },
    gift: {
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            width: "100%",
        },
    },
    giftTitle: {
        width: "20%",
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            textAlign: "center",
            paddingRight: 0,
        },
    },
    giftContent: {
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            width: "100%",
        },
    },
    giftImg: {
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            height: 200,
        },
    },
    overlayBackground: {
        zIndex: 1,
        background: "rgba(200,200,200,0.8)",
        position: "absolute",
        width: "100%",
        height: "100%",
    },
    overlayButton: {
        background: "#fff",
        borderRadius: "25px",
        cursor: "pointer",
        maxWidth: "250px",
        margin: "auto",
        textAlign: "center",
        marginTop: "20%",
    },
    overlayContainer: {
        width: "100%",
        position: "relative",
    },
    flex: {
        display: "flex",
    },
});
